import { ApplicationStage } from '../../../api/types';
import ListPageInner from '../../shared/ApplicationListPage/ListPageInner';

const AppointmentListPage = () => {
    const stage = ApplicationStage.Appointment;
    const namespace = 'appointmentList';

    return <ListPageInner namespace={namespace} stage={stage} />;
};

export default AppointmentListPage;
